import { render, staticRenderFns } from "./ListSubsidiary.vue?vue&type=template&id=51c2da06"
import script from "./ListSubsidiary.vue?vue&type=script&lang=js"
export * from "./ListSubsidiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports